/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';

import { getIsMobile } from '../state/site/selectors';

interface HOCProps {
  isMobile: boolean;
}

const forDevice = <MobileProps, DesktopProps>(
  ComponentMobile: React.ComponentType<MobileProps>,
  ComponentDesktop: React.ComponentType<DesktopProps>,
) => {
  const mapStateToProps = (state: any) => ({ isMobile: getIsMobile(state) });

  const HOC: React.ComponentType<DesktopProps & MobileProps & HOCProps> = (props) =>
    props.isMobile ? <ComponentMobile {...props} /> : <ComponentDesktop {...props} />;

  return connect<{}, {}, DesktopProps & MobileProps>(mapStateToProps)(HOC);
};

export default forDevice;
